export const CUSTOMER_PORTAL_BACKGROUND_COLOR = '#ecedee';
export const CUSTOMER_PORTAL_HEADING_COLOR = '#1a1a1a';
export const CUSTOMER_PORTAL_TEXT_COLOR = '#374151';
